import React, { Fragment, useEffect, useState } from 'react'
import Logo from "../../images/logo.png"
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from "react-redux";
import { loginAction, clearErrors, forgotPasswordAction } from "../../../redux/actions/userActions";
import Loader from '../../loader/loader';
import Img1 from "../../images/globe.png";
import { FORGET_PASSWORD_RESET } from '../../../redux/constants/userConstants';
import usePageMeta from '../../../hooks/usePageMeta';



const Login = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();


  const { loading, error, message } = useSelector((state) => state.register);
  const { isAuthenticated, user } = useSelector((state) => state.verifyEmailStore);

  const { loading: forgotLoading,
    error: forgotError,
    message: forgotMessage
  } = useSelector((state) => state.forgotPassword);


  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showFogotSection, setshowFogotSection] = useState(false)
  const [isSubmit, setIssubmit] = useState(false)
  const [isForgotSubmit, setisForgotSubmit] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  usePageMeta("login");


  const handleSubmit = (e) => {
    e.preventDefault()

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    if (!password) {
      toast.error("please Enter your Password")
      return
    }
    if (password.length < 8) {
      toast.error("Password should contain atleast 8 digits")
      return
    }

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    dispatch(loginAction(formData));

    setIssubmit(true)

  }



  useEffect(() => {
    if (message && isSubmit) {
      toast.success(message);
      localStorage.setItem("email", email);
      navigate('/verify-email');
      setIssubmit(false)
    }
    if (error) {
      toast.error(error);
      dispatch(clearErrors());
    }
    if (isAuthenticated) {
      navigate(user?.role === 'Admin' ? '/admin' : '/')
    }
  }, [error, message, navigate, dispatch, email, isAuthenticated, isSubmit, user]);








  const handleForgotSubmit = (e) => {
    e.preventDefault()

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }


    const userData = {
      email: email,
    }

    dispatch(forgotPasswordAction(userData))

    setisForgotSubmit(true)
  }

  useEffect(() => {
    if (forgotError) {
      toast.error(forgotError)
      dispatch(clearErrors())
    }

    if (forgotMessage && isForgotSubmit) {
      toast.success(forgotMessage)
      navigate('/forgot-password')
      localStorage.setItem("email", email);
      dispatch({ type: FORGET_PASSWORD_RESET })
    }

  }, [forgotError, dispatch, forgotMessage, navigate, email, isForgotSubmit])


  return (
    <Fragment>
      {loading || forgotLoading ? <Loader /> :
        <>
          <section className="min-h-[100vh] flex items-center justify-center p-[2vmax] lg:p-[3vmax] signPage">
            <div className="flex justify-between bg-white 
                        rounded-[1vmax] p-[2vmax] w-[100%] lg:w-[80%] relative z-10 shadow-3 flex-col md:flex-row">
              <div className="md:w-[52%]">
                <div className='w-[12vmax] h-fit mx-auto md:mx-0'>
                  <img src={Logo} alt="logo" className='w-[100%]' />
                </div>
                <div className='md:w-[100%] flex-center animate-3d'>
                  <img src={Img1} alt="logo" className='hidden md:block w-[100%]' />
                </div>
              </div>

              <div className="flex w-[100%] md:w-[44%]">
                <form className="flex flex-col justify-center items-center md:items-start w-[100%]  lg:w-[85%]" onSubmit={handleSubmit}>
                  <h4 className='font-1 flex items-center text-[2vmax] lg:text-[1.6vmax] font-bold pt-[1vmax] md:pt-[0vmax]'>Welcome back
                  </h4>
                  <p className='pt-[0.2vmax] text-[1.5vmax] lg:text-[1.1vmax]' >Your Admin Dashboard</p>

                  {/* Email */}
                  <div className='flex flex-col mt-[3vmax] md:mt-[6vmax] w-full'>
                    <span className='text-[1.5vmax] lg:text-[1.1vmax]' >Email Address <span className='text-red-500'>*</span></span>
                    <input
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className='border-[0.15vmax] px-[2vmax] py-[0.7vmax] rounded-[0.6vmax] mt-[0.7vmax] outline-blue-400 text-[1.8vmax] lg:text-[1.1vmax]'
                    />
                  </div>

                  {/* Password */}
                  <div className='flex flex-col mt-[1vmax] relative  w-full'>
                    <span className='text-[1.5vmax] lg:text-[1.1vmax]'  >Password <span className='text-red-500'>*</span></span>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className='border-[0.15vmax] px-[2vmax] py-[0.7vmax] rounded-[0.6vmax] mt-[0.7vmax] outline-blue-400 text-[1.8vmax] lg:text-[1.1vmax]'
                    />
                    <button type='button'
                      className='absolute top-[3.5vmax] lg:top-[2.9vmax] right-[1.5vmax] text-[1.8vmax] lg:text-[1.1vmax]'
                      onClick={() => setShowPassword(prev => !prev)}>
                      <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                    </button>
                  </div>
                  <button className='w-full text-right pt-[0.4vmax] text-[1.5vmax] lg:text-[1.2vmax]' type="button" onClick={() => setshowFogotSection(true)}>Forgot Password?</button>

                  <div className="w-[100%] text-center">

                    <button
                      type='submit'
                      className='bg-[image:var(--gradient)] my-[2vmax] py-[0.7vmax] rounded-[2vmax] text-white font-bold shadow-2 px-[2vmax] hover:scale-[0.9] text-[1.8vmax] lg:text-[1.2vmax]'
                    >
                      Sign In
                    </button>
                  </div>

                  <h4 className='text-[1.5vmax] lg:text-[1.2vmax] pb-[2vmax] md:p-0' >
                    Don't have an account? <Link to={'/signup'} className='text-[var(--color-2)]'>&nbsp;Sign up</Link>
                  </h4>
                </form>
              </div>
            </div>
          </section>
          <section className="flex-center fixed top-0 left-0 bg-[#000000ea] w-[100%] min-h-[100vh] z-[100]"
            style={{ display: `${showFogotSection ? "flex" : "none"}` }}>
            <form className="loginSignup flex flex-col bg-white p-[2vmax] rounded-[1vmax] w-[80%] lg:w-[30%]" onSubmit={handleForgotSubmit}>
              <h4 className='text-[var(--color-2)] font-bold text-[2vmax] lg:text-[1.5vmax] text-center font-3' >Forgot your Password</h4>
              <div className='flex flex-col mt-[1vmax]'>
                <span className='text-[1.5vmax] lg:text-[1.2vmax]' >Email Address <span className='text-red-500'>*</span></span>
                <input
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className='border-[0.15vmax] px-[2vmax] py-[0.7vmax] rounded-[0.6vmax] mt-[0.7vmax] outline-blue-400 text-[1.5vmax] lg:text-[1.1vmax]'
                />
              </div>
              <button type='submit' className='bg-[image:var(--gradient)] mt-[2vmax] py-[0.7vmax] rounded-[2vmax] text-white font-bold shadow-2 block hover:scale-[0.9] text-[1.5vmax] lg:text-[1.2vmax]' >Forgot Password</button>
            </form>
            <button className='fixed top-[2vmax] right-[2vmax] text-white text-[3vmax]' onClick={() => setshowFogotSection(false)}>
              <i className="fa-solid fa-xmark-circle"></i>
            </button>
          </section>
        </>
      }

    </Fragment >

  )
}

export default Login